import { render, staticRenderFns } from "./FarmersNeeds.vue?vue&type=template&id=9469dbd8&"
import script from "./FarmersNeeds.vue?vue&type=script&lang=js&"
export * from "./FarmersNeeds.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports